import { BehaviorSubject } from 'rxjs';

// Tracks which flights are hidden from the map overlay, by id. Absent from
// the set (the default for every flight) means visible.
function createFlightsVisibilityService() {
  const hiddenIds$ = new BehaviorSubject<Set<string>>(new Set());

  function isVisible(id: string): boolean {
    return !hiddenIds$.value.has(id);
  }

  function setVisible(id: string, visible: boolean) {
    const next = new Set(hiddenIds$.value);
    if (visible) next.delete(id);
    else next.add(id);
    hiddenIds$.next(next);
  }

  function showAll() {
    hiddenIds$.next(new Set());
  }

  function hideAll(ids: string[]) {
    hiddenIds$.next(new Set(ids));
  }

  return { hiddenIds$, isVisible, setVisible, showAll, hideAll };
}

export const flightsVisibilityService = createFlightsVisibilityService();
